/*
  Aantal-stepper op de productpagina (hoofdblok + sticky koopbalk).
  Herschreven 27-10-2026 (Claude): de teller ging uit van de waarde bij het laden (1),
  terwijl de minimale afname (bijv. 250) daarna door een app werd ingesteld. Een klik op +
  gaf dan 2 in plaats van 251. Nu wordt bij elke klik de actuele waarde, het minimum en de
  stap van het invoerveld gebruikt.
*/
!(function () {
  const contents = document.querySelectorAll(".main-product__content");
  const sticky = document.querySelector(".sticky-add-to-cart");

  const num = (v, fallback) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  };

  contents.forEach((content) => {
    const visibleInputs = [content.querySelector(".quantity input"), sticky && sticky.querySelector(".quantity input")].filter(Boolean);
    const hiddenInputs = [content.querySelector("#quantity"), sticky && sticky.querySelector("#quantity")].filter(Boolean);
    if (!visibleInputs.length || !hiddenInputs.length) return;

    const minOf = () => Math.max(1, ...visibleInputs.map((i) => num(i.min, 1)));
    const stepOf = () => Math.max(1, ...visibleInputs.map((i) => num(i.step, 1)));
    const current = () => Math.max(minOf(), ...visibleInputs.map((i) => num(i.value, 1)));

    const apply = (value, notify) => {
      visibleInputs.forEach((i) => {
        i.value = value;
      });
      hiddenInputs.forEach((h) => {
        h.value = value;
      });
      if (notify) {
        visibleInputs.forEach((i) => i.dispatchEvent(new Event("change", { bubbles: true })));
      }
    };

    const bind = (scope) => {
      if (!scope) return;
      const plus = scope.querySelector('button[name="plus"]');
      const minus = scope.querySelector('button[name="minus"]');
      const input = scope.querySelector(".quantity input");
      if (!plus || !minus || !input) return;

      plus.addEventListener("click", () => apply(current() + stepOf(), true));
      minus.addEventListener("click", () => apply(Math.max(minOf(), current() - stepOf()), true));
      input.addEventListener("change", (e) => {
        if (e.isTrusted === false) return; // door ons eigen apply() uitgezonden
        const typed = num(e.target.value, minOf());
        apply(Math.max(minOf(), typed), false);
      });
      input.addEventListener("keypress", (e) => {
        if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) e.preventDefault();
      });
    };

    bind(content);
    bind(sticky);
  });
})();
